import { render } from "./Organizer.vue?vue&type=template&id=56f63e7d&scoped=true"
import script from "./Organizer.vue?vue&type=script&lang=js"
export * from "./Organizer.vue?vue&type=script&lang=js"

import "./Organizer.vue?vue&type=style&index=0&id=56f63e7d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f63e7d"]])

export default __exports__